import { Notifier as AirbrakeNotifier } from '@airbrake/browser'
import { setupAirbrake } from '@dpgradio/creative'

export default defineNuxtPlugin(async (nuxtApp) => {
  if (!import.meta.dev) {
    await setupAirbrake(
      AirbrakeNotifier,
      {
        environment: 'production',
        projectId: 639957,
        projectKey: '99a61f30e1b740c37aacac1acf9c126f',
      },
      nuxtApp.vueApp
    )
  }
})
